<template>
    <div class="box">
        <h3 class="title reveal-bottom">Construction</h3>
        <div class="wrap">
            <Item
                :imgUrl="img"
                title="No Power, No Carrier Line, No Problem"
                subTitle="Segmenting PCI traffic, replacing routers, single-click profile deployment — Salon Service Group uses outcome-driven networking to grow the business."
                id="1"
            />
            <Item
                :imgUrl="img"
                title="No Power, No Carrier Line, No Problem"
                subTitle="Segmenting PCI traffic, replacing routers, single-click profile deployment — Salon Service Group uses outcome-driven networking to grow the business."
                id="2"
            />
            <Item
                :imgUrl="img"
                title="No Power, No Carrier Line, No Problem"
                subTitle="Segmenting PCI traffic, replacing routers, single-click profile deployment — Salon Service Group uses outcome-driven networking to grow the business."
                id="3"
            />
            <Item
                :imgUrl="img"
                title="No Power, No Carrier Line, No Problem"
                subTitle="Segmenting PCI traffic, replacing routers, single-click profile deployment — Salon Service Group uses outcome-driven networking to grow the business."
                id="4"
            />
            <Item
                :imgUrl="img"
                title="No Power, No Carrier Line, No Problem"
                subTitle="Segmenting PCI traffic, replacing routers, single-click profile deployment — Salon Service Group uses outcome-driven networking to grow the business."
                id="5"
            />
            <Item
                :imgUrl="img"
                title="No Power, No Carrier Line, No Problem"
                subTitle="Segmenting PCI traffic, replacing routers, single-click profile deployment — Salon Service Group uses outcome-driven networking to grow the business."
                id="6"
            />
        </div>
    </div>
</template>
<script>
import Item from "./Item.vue";
export default {
    data() {
        return {
            img: require("@/assets/images/customer/customer.png"),
        };
    },

    components: {
        Item,
    },
};
</script>
<style scoped>
.box {
    width: 1200px;
    margin: 100px auto 100px;
}
.title {
    font-size: 44px;
    color: #000;
    line-height: 66px;
}
.wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Customer/Construction.vue